<template>
  <div class="row">
    <div class="col-md-6">
      <shepaChart
        type_opration="count"
        :chartdatas="ChartDataRegister"
        :charttype="'line'"
        :group_col="'daily'"
        :XYTitle="'عنوان'"
        :columns="[
          {
            name: 'تعداد کل تراکنش ها',
            field_name: 'cost',
            field_type: 'count',
          },
        ]"
        :title="'تعداد تراکنش های ریالی'"
        :biId="-2"
      ></shepaChart>
    </div>
    <div class="col-md-6">
      <shepaChart
        type_opration="sum"
        :chartdatas="ChartDataRegister"
        :charttype="'line'"
        :group_col="'daily'"
        :XYTitle="'عنوان'"
        :columns="[
          {
            name: 'مبلغ کل ثبت نامی ها',
            field_name: 'cost',
            field_type: 'count',
          },
        ]"
        :title="'مبلغ تراکنش های ریالی'"
        :biId="-2"
      ></shepaChart>
    </div>
    <div class="col-md-6">
      <shepaChart
        type_opration="count"
        :chartdatas="ChartDataDollar"
        :charttype="'line'"
        :group_col="'daily'"
        :XYTitle="'عنوان'"
        :columns="[
          {
            name: 'تعداد کل تراکنش ها',
            field_name: 'cost',
            field_type: 'count',
          },
        ]"
        :title="'تعداد تراکنش های دلاری'"
        :biId="-2"
      ></shepaChart>
    </div>
    <div class="col-md-6">
      <shepaChart
        type_opration="sum"
        :chartdatas="ChartDataDollar"
        :charttype="'line'"
        :group_col="'daily'"
        :XYTitle="'عنوان'"
        :columns="[
          {
            name: 'مبلغ کل ثبت نامی ها',
            field_name: 'cost',
            field_type: 'count',
          },
        ]"
        :title="'مبلغ تراکنش های دلاری'"
        :biId="-2"
      ></shepaChart>
    </div>
  </div>
</template>
<script>
import ShepaChart from "@/components/Chart";
import httpHelper from "../../helpers/httpHelper";
import moment from "jalali-moment";
export default {
  name: "report2",
  data() {
    return {
      ChartDataRegister: [],
      ChartDataDollar: [],
    };
  },
  components: { ShepaChart },
  mounted() {
    var dateFrom = moment().add(-30, "day").format("jYYYY/jMM/jDD");
    var dateto = moment().format("jYYYY/jMM/jDD");

    httpHelper
      .getData(
        `~transaction/charts/TransactionCount?datefrom=${dateFrom}&dateto=${dateto}&rialOrDollar=483`
      )
      .then((res) => {
        this.ChartDataRegister = res;
      });
    httpHelper
      .getData(
        `~transaction/charts/TransactionCount?datefrom=${dateFrom}&dateto=${dateto}&rialOrDollar=1722`
      )
      .then((res) => {
        this.ChartDataDollar = res;
      });
  },
};
</script>